import React from 'react';
import { MatchSource } from './types';

interface StatusBadgeProps {
  status: string;
  source: MatchSource;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, source }) => {
  const s = status?.toLowerCase() || '';
  if (s === 'played' || s === 'finished') {
    return <span className="px-2 py-1 text-xs font-medium rounded-full bg-green-100 text-green-800 dark:bg-green-900/50 dark:text-green-300">Played</span>;
  }
  if (s === 'scheduled' || s === 'fixture' || s === 'pending' || s === 'confirmed') {
    return <span className="px-2 py-1 text-xs font-medium rounded-full bg-blue-100 text-blue-800 dark:bg-blue-900/50 dark:text-blue-300">Upcoming</span>;
  }
  if (s === 'in_play') {
    return <span className="px-2 py-1 text-xs font-medium rounded-full bg-orange-100 text-orange-800 dark:bg-orange-900/50 dark:text-orange-300">Live</span>;
  }
  if (s === 'postponed') {
    return <span className="px-2 py-1 text-xs font-medium rounded-full bg-yellow-100 text-yellow-800 dark:bg-yellow-900/50 dark:text-yellow-300">Postponed</span>;
  }
  if (s === 'cancelled') {
    return <span className="px-2 py-1 text-xs font-medium rounded-full bg-red-100 text-red-800 dark:bg-red-900/50 dark:text-red-300">Cancelled</span>;
  }
  return <span className="px-2 py-1 text-xs font-medium rounded-full bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300">{status}</span>;
};

export default StatusBadge;
